import { render } from "./Form.vue?vue&type=template&id=60cb9dd4&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=60cb9dd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cb9dd4"]])

export default __exports__